import axios from '../../../../../api/axios';

export const initialState = {
  loaded: false,
  values: {
    fleetCount: 1,
    payType: 'atDestination',
    waybillType: 'software',
    unloadTime: 'day',
    weighbridge: false,
  },
  error: {},
};
export const reducer = (state, actions) => {
  const { payload, type } = actions;
  switch (type) {
    case 'LOADING':
      return { ...state, loaded: false };
    case 'PRICE':
      return {
        ...state,
        values: {
          ...state.values,
          proposedPrice: payload?.proposedPrice,
          basePrice: payload?.basePrice,
        },
      };
    case 'LOADED':
      return { ...state, loaded: true };
    case 'ERROR':
      return { ...state, error: payload };
    case 'REORDER':
      return { ...state, values: { ...state.values, ...payload } };
    case 'CHANGE_VALUES':
      const { name, value } = payload;
      return { ...state, values: { ...state.values, [name]: value } };
    default:
      return state;
  }
};

export const actions = {
  calcInsurance: async (cargoValue) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/order/insuranceOfOrder/${cargoValue}`
      );
      if (data?.ok) return data?.insurance;
    } catch (error) {
      throw error;
    }
  },
};
